import script from "./UpsellAfterCancelModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./UpsellAfterCancelModal.vue?vue&type=script&setup=true&lang=ts"

import "./UpsellAfterCancelModal.vue?vue&type=style&index=0&id=65cc932e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65cc932e"]])

export default __exports__